import { Component, inject } from "@angular/core";
import {
  SnackbarService,
  SnackItem,
} from "../services/snackbar/snackbar.service";
import {
  concat,
  concatMap,
  ignoreElements,
  of,
  Subject,
  takeUntil,
  timer,
} from "rxjs";
import { NgTemplateOutlet, NgClass } from "@angular/common";
@Component({
  selector: "app-snackbar",
  standalone: true,
  imports: [NgTemplateOutlet, NgClass],
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.scss"],
})
export class SnackbarComponent {
  currentSnack: SnackItem | null = null;
  snackService = inject(SnackbarService);
  dismissTimeout?: ReturnType<typeof setTimeout>;
  private destroy$ = new Subject<void>();

  constructor() {
    // ? https://stackoverflow.com/questions/68414582/rxjs-operator-to-delay-handling-subsequent-events
    this.snackService.snack$
      .pipe(
        takeUntil(this.destroy$),
        concatMap(
          // Emit immediately, then wait for duration + leave animation time before emitting next
          (snack) => {
            const leaveAnimationDuration = 300; // match .leave-animation duration in scss
            return concat(
              of(snack),
              timer((snack.duration ?? 3000) + leaveAnimationDuration).pipe(
                ignoreElements(),
              ),
            );
          },
        ),
      )
      .subscribe((snack) => {
        this.showSnack(snack);
      });
  }

  ngOnInit() {}

  private showSnack(snack: SnackItem) {
    this.currentSnack = snack;

    // auto dismiss after duration
    if (!snack.persistent) {
      this.dismissTimeout = setTimeout(() => {
        this.dismissSnack();
      }, snack.duration ?? 3000);
    }
  }

  private dismissSnack() {
    clearTimeout(this.dismissTimeout);
    this.currentSnack = null;
  }

  ngOnDestroy() {
    clearTimeout(this.dismissTimeout);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
